import { StackProps, VStack } from '@droplet-tech-code/core-elements/module/ui/Stack';
import { isNativeMobile } from '@droplet-tech-code/core-elements/module/utils/utils.helper';

export const SwitchStack = (props: StackProps) => {
  return <VStack {...props} row={props.row ?? !isNativeMobile} />;
};
